import { render, staticRenderFns } from "./ApprovedNegatori.vue?vue&type=template&id=7f2f618a&"
import script from "./ApprovedNegatori.vue?vue&type=script&lang=js&"
export * from "./ApprovedNegatori.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports